<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template pmWidgetTitle infoTooltipText="{{ infoTooltipText }}">
    {{ 'RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    <!--TODO make selection possible again when PM-1639 is done
    <mat-form-field
      color="primary"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>
        {{ 'RESULT.INSIGHTS.GENERAL.SELECT_FILTER' | translate }}
      </mat-label>
      // TODO make this select with virtual-select-field-component when PM-1639 is done
      <mat-select
        [(value)]="selectedFilterGroup"
        [disabled]="isLoading"
        (selectionChange)="getPlanningAccuracyData(true)"
      >
        @for (filterName of this.availableFilters(); track $index) {
          <mat-option [value]="filterName.column"
            >{{ filterName.column }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      color="primary"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      <mat-label>
        {{ 'RESULT.INSIGHTS.GENERAL.SELECT_DATASET' | translate }}
      </mat-label>
      <mat-select
        [(value)]="selectedFilterOption"
        [disabled]="isLoading"
        (selectionChange)="getPlanningAccuracyData(false)"
      >
      // TODO make this select with virtual-select-field-component when PM-1639 is done
        @for (filterOption of filterOptionsByFilterGroup; track $index) {
          <mat-option [value]="filterOption">{{ filterOption }} </mat-option>
        }
      </mat-select>
    </mat-form-field>-->

    <!-- Readonly mode until PM-1639 is done -->
    <pm-form-field
      label="RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.VIEW_FILTER"
    >
      <pm-form-input-text
        [readonly]="true"
        [disabled]="isError"
        [(ngModel)]="selectedFilterGroup"
      />
    </pm-form-field>

    <pm-form-field
      label="RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.VIEW_DATASET"
    >
      <pm-form-input-text
        [readonly]="true"
        [disabled]="isError"
        [(ngModel)]="selectedFilterOption"
      />
    </pm-form-field>
  </ng-template>

  <ng-template pmWidgetContent>
    @if (this.isError) {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
        </pm-h3>
      </div>
    } @else if (this.isNoDataAvailable) {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{ 'UTILITY.PLACEHOLDER_NO_DATA_AVAILABLE' | translate }}
        </pm-h3>
      </div>
    } @else {
      <highcharts-chart
        class="w-full"
        id="planning-accuracy-chart"
        [oneToOne]="true"
        [options]="chartOptions()"
      >
      </highcharts-chart>
    }
  </ng-template>

  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(PlanningAccuracyWidgetComponent, {
            resolution: resolution,
            planningPeriod: planningPeriod,
            filterGroup: selectedFilterGroup,
            filterOption: selectedFilterOption,
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
